(function idleValue(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Modules = global.NewHomeSource.Modules || {};

  if (!global.NewHomeSource.Modules.requestIdleCallback) {
    return;
  }

  const previousIdleValue = global.NewHomeSource.Modules.IdleValue;
  const cancelIdleCallbackFunction = global.NewHomeSource.Modules.requestIdleCallback.cIC;
  const requestIdleCallbackFunction = global.NewHomeSource.Modules.requestIdleCallback.rIC;

  /**
   * @private
   *
   * initVariable: assign the value of the variable from the callback;
   */
  function initVariable() {
    this.value = this.callback();
  }

  /**
   * @constructs NewHomeSource.Modules.IdleValue
   *
   * @param {function} callback that initializes a value for a variable.
   */
  function IdleValue(callback) {
    this.callback = callback;
    this.value = undefined;
    this.init = requestIdleCallbackFunction(initVariable.bind(this));
  }

  /**
   * @public
   * cancelIdleInit: cancels the init of the IdleValue.
   */
  IdleValue.prototype.cancelIdleInit = function cancelIdleInit() {
    if (!this.init) {
      return;
    }

    cancelIdleCallbackFunction(this.init);
    this.init = null;
  };

  /**
   * @public
   * getValue: gets the value from the IdleValue.
   *
   * @param {boolean} retryIfNull take null value as wrong values and execute the callback.
   */
  IdleValue.prototype.getValue = function getValue(retryIfNull) {
    if (this.value === undefined || (retryIfNull && this.value === null)) {
      this.cancelIdleInit();
      this.value = this.callback();
    }

    return this.value;
  };

  /**
   * @public
   * setValue: sets a new value to the IdleValue.
   *
   * @param {any} value to be assigned.
   */
  IdleValue.prototype.setValue = function setValue(value) {
    this.cancelIdleInit();
    this.value = value;
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.Modules.IdleValue to the previous script.
   */
  IdleValue.noConflict = function noConflict() {
    global.NewHomeSource.Modules.IdleValue = previousIdleValue;
    return IdleValue;
  };

  global.NewHomeSource.Modules.IdleValue = IdleValue;
}(window));
